import { useState, useEffect, } from 'react';
import { i18nLibraryInstance, initializeLibraryI18n } from './library.js';
export const useI18n = (currentLanguage) => {
    const [isInitialized, setIsInitialized] = useState(false);
    useEffect(() => {
        if (!i18nLibraryInstance.isInitialized) {
            const initialize = async () => {
                await initializeLibraryI18n();
                setIsInitialized(true);
            };
            initialize();
        }
        else {
            setIsInitialized(true);
        }
    }, []);
    useEffect(() => {
        if (currentLanguage && isInitialized) {
            i18nLibraryInstance.changeLanguage(currentLanguage);
        }
    }, [currentLanguage, isInitialized]);
    return {
        isInitialized,
        i18n: i18nLibraryInstance,
    };
};
